module.exports = __webpack_public_path__ + "img/rotate-blue-16dp.ee24db9b.svg";